import {FormField, FormFieldType, SelectionOption} from 'lionheartland';
import {ENInterval} from '../../enums';

export class PostPriceFormFields {

    public name: FormField
    public sku: FormField
    public exRef: FormField
    public amount: FormField
    public trailDays: FormField
    public interval: FormField
    public active: FormField
    public product: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.sku = new FormField(
          'sku',
          'Sku',
          null,
          FormFieldType.text,
          true,
        )
        this.exRef = new FormField(
          'exRef',
          'Ex ref',
          null,
          FormFieldType.text,
          false,
        )
        this.amount = new FormField(
          'amount',
          'Amount',
          null,
          FormFieldType.text,
          true,
        )
        this.trailDays = new FormField(
          'trailDays',
          'Trail days',
          null,
          FormFieldType.text,
          true,
        )
        this.interval = new FormField(
          'interval',
          'Interval',
          null,
          FormFieldType.enumeration,
          true,
        )
        this.interval.enumeration = ENInterval
        this.active = new FormField(
          'active',
          'Active',
          null,
          FormFieldType.boolean,
          true,
          true,
          true
        )
        this.product = new FormField(
          'product',
          'Product',
          'product',
          FormFieldType.pushedSelectionList,
          true,
        )

    }
}

const fields = new PostPriceFormFields()

export const postPriceFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  sku: fields.sku,
  exRef: fields.exRef,
  amount: fields.amount,
  trailDays: fields.trailDays,
  interval: fields.interval,
  active: fields.active,
  product: fields.product,
};